import { general } from 'src/config'
import store from 'src/store'

function formatMoney (value, currency = undefined, minimumFractionDigits = undefined, maximumFractionDigits = undefined) {
  return Intl.NumberFormat(store.getters.locale, {
    style: 'currency',
    currencyDisplay: 'symbol',
    currency: currency || general.base_currency,
    minimumFractionDigits,
    maximumFractionDigits
  }).format(value / 100)
}

function formatPercentage (value, minimumFractionDigits = undefined, maximumFractionDigits = undefined) {
  return Intl.NumberFormat(store.getters.locale, {
    style: 'percent',
    minimumFractionDigits,
    maximumFractionDigits
  }).format(value)
}

function formatNumber (value, locale = undefined) {
  return Intl.NumberFormat('de-DE').format(value)
}

function secondsToHumanReadable (timeInSeconds) {
  const time = parseFloat(timeInSeconds).toFixed(3)
  const hours = Math.floor(time / 60 / 60)
  const minutes = Math.floor(time / 60) % 60
  const seconds = Math.floor(time - minutes * 60)

  return hours + ':' + padInteger(minutes, 2) + ':' + padInteger(seconds, 2)
}

function padInteger (integer, size) {
  return ('000' + integer).slice(size * -1)
}

export { formatMoney, formatPercentage, formatNumber, secondsToHumanReadable, padInteger }
